import React from "react";
import { Button } from "semantic-ui-react";
import ProcessFuelFlowPSM1 from "./ProcessFuelFlowPSM1";

const ProcessFuelPSM1 = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <ProcessFuelFlowPSM1 schedule={"normal"} />;
      case "2":
        return <ProcessFuelFlowPSM1 schedule={"CL_Schd"} />;
      default:
        return <ProcessFuelFlowPSM1 schedule={"normal"} />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="Process Fuel Flow Page 1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="Process Fuel Flow Page 2"
        />
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default ProcessFuelPSM1;
